import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('OptionModel')
export default class OptionModel {
  @JsonProperty('label', String)
  public label:string = '';
  @JsonProperty('value', String)
  public value:string = '';
}
